<template>
  <div class="step-container scrollPosition baugrundstueck-step-3">
    <div class="step-header">
      <h2 class="step-title">Verwendungszweck</h2>
      <p class="step-text">Wofür benötigen Sie den Immobiliencheck?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-50"
          text="Kauf"
          @click="setVerwendung('KAUF')"
          :iconDefault="require('@/assets/icons/Svgs/Baugrundstueck_Kauf.svg')"
          :iconHover="
            require('@/assets/icons/Svgs/Baugrundstueck_Kauf_white.svg')
          "
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Verkauf"
          @click="setVerwendung('VERKAUF')"
          :iconDefault="require('@/assets/icons/Svgs/Baugrundstueck_Verkauf.svg')"
          :iconHover="
            require('@/assets/icons/Svgs/Baugrundstueck_Verkauf_white.svg')
          "
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Bestandsimmobilie"
          @click="setVerwendung('BESTAND')"
          :iconDefault="require('@/assets/icons/Svgs/Baugrundstueck_Bestand.svg')"
          :iconHover="
            require('@/assets/icons/Svgs/Baugrundstueck_Bestand_white.svg')
          "
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";
import {  saveToStorage } from "@/utils.js";
export default {
  name: "baugrundstueck-step-3",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        f_zweck: { value: null },
      },
    };
  },
  methods: {
    setVerwendung(f_zweck) {
      this.fields.f_zweck.value = f_zweck;
      saveToStorage(this.fields);
      this.$router.push("/baugrundstueck-step-4");
    },
    goBack() {

        this.$router.push("/baugrundstueck-step-2");

    },
  },
  mounted() {
    this.$emit("setStep", "baugrundstueck", 4);
  },
};
</script>
<style scoped>
.box-item {
  flex-basis: 250px;
  height: 200px;
}
@media only screen and (max-width: 768px) {
  .box-container {
    grid-auto-rows: minmax(150px, auto);
  }
  .box-item {
    height: 100%;
  }
}
</style>
